import { useStateMachine } from 'little-state-machine';

import { Button } from 'react-bootstrap';
import { MdOutlineClose } from 'react-icons/md';
import { useIntl, FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import clearStore from '../../clearStore';

function CancelFormButton({ backTo }) {
  const intl = useIntl();
  const navigate = useNavigate();
  const { actions } = useStateMachine({ clearStore });
  const handleCancelForm = () => {
    Swal.fire({
      title: intl.formatMessage({ id: 'cancel_question' }),
      text: intl.formatMessage({ id: 'cancel_info' }),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({ id: 'Ok' }),
      cancelButtonText: intl.formatMessage({ id: 'No' }),
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        navigate(backTo ? backTo : '/');
        actions.clearStore();
      }
    });
  };
  return (
    <Button
      variant="outline-danger"
      className="btn-sm d-flex align-items-center justify-content-center"
      onClick={handleCancelForm}>
      <MdOutlineClose className="me-2" /> <FormattedMessage id="button.cancel" />
    </Button>
  );
}

export default CancelFormButton;
